export interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

export const countries: Country[] = [
  {
    code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷',
  },
  {
    code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸',
  },
  {
    code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦',
  },
  {
    code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽',
  },
  {
    code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷',
  },
  {
    code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱',
  },
  {
    code: 'CO', name: 'Colômbia', dialCode: '+57', flag: '🇨🇴',
  },
  {
    code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪',
  },
  {
    code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪',
  },
  {
    code: 'PY', name: 'Paraguai', dialCode: '+595', flag: '🇵🇾',
  },
  {
    code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹',
  },
  {
    code: 'ES', name: 'Espanha', dialCode: '+34', flag: '🇪🇸',
  },
  {
    code: 'FR', name: 'França', dialCode: '+33', flag: '🇫🇷',
  },
  {
    code: 'DE', name: 'Alemanha', dialCode: '+49', flag: '🇩🇪',
  },
  {
    code: 'IT', name: 'Itália', dialCode: '+39', flag: '🇮🇹',
  },
  {
    code: 'UK', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧',
  },
];

export const DEFAULT_COUNTRY_CODE = 'BR';

export function getCountryByCode(code: string): Country {
  return countries.find(country => country.code === code) ?? countries[0];
}
